<template>
    <div class="jump-cart">
        <van-nav-bar title="消费任务" left-arrow fixed class="jump-nav-bar" @click-left="back"/>
          <van-field v-if="!isData"
                            v-model="startTime"
                            label="开始时间"
                            placeholder="请选择开始时间"
                            @focus="showStart=true"
                            readonly
                    >
                     <!-- <van-button slot="button" size="small" type="primary" @click="search">搜索</van-button> -->
          </van-field>
                    
        <div class="jump-cart-body">

            <van-row v-if="isData" style="text-align: center">
                {{msg}}
            </van-row>
            <van-row class="jump-cart-item" v-else>
                <van-col span="14">
                    当月消费任务（元）
                </van-col>
                <van-col span="10">
                    差额（元）
                </van-col>

                <van-col span="14">
                    {{data.task_price_one}}
                </van-col>
                <van-col span="10">
                    {{data.umilk_price_differ_one}}
                </van-col>

                <van-col span="14">
                    {{data.task_price_two}}
                </van-col>
                <van-col span="10">
                    {{data.umilk_price_differ_two}}
                </van-col>

                <van-col span="14">
                    {{data.task_price_three}}
                </van-col>
                <van-col span="10">
                    {{data.umilk_price_differ_three}}
                </van-col>


                <van-col span="24">
                    已消费金额： {{data.upricev}}
                </van-col>
                <van-col span="24">
                    当前可享受赠送商品金额： {{data.umilk_price_level}}
                </van-col>
            </van-row>
        </div>
        <BackTop/>
        <!-- 开始时间 -->
        <van-popup v-model="showStart" position="bottom" :overlay="true">
            <van-datetime-picker
                    v-model="currentDate"
                    :formatter="formatter"
                     type="year-month"
                    :min-date="minDate"
                    @cancel="showStart = false"
                    @confirm="onDateConfirm"

            />
        </van-popup>
    </div>
</template>
<script>
    import {NavBar, Row, Col, List,DatetimePicker,Popup,Field,Button} from "vant";

    export default {
        name: "userhistory",
        components: {
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [List.name]: List,
            [DatetimePicker.name]: DatetimePicker,
            [Popup.name]: Popup,
            [Field.name]: Field,
            [Button.name]: Button,
        },
        data() {
            return {
                data: {},
                isData:false,
                msg:'',
                showStart:false,
                startTime:'',
                currentDate:new Date(),
                minDate: new Date(2019, 9, 1),
                userId:this.$route.query.userId,
            };
        }, mounted: function () {
            let that = this
            that.$api.get(
                that.jumuc.getUserSysMilkDiscount,
                 {orderTime:this.startTime,userId:this.userId},
                successRes => {
                    if (successRes.success) {
                        that.data = successRes.data;
                        
                    } else {
                        that.isData = true
                        that.msg=successRes.msg
                    }
                })
        },
        methods: {
            back() {
                history.back();
            },
            onDateConfirm (value){
                 const d = new Date(value)
                const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1));
                this.startTime=resDate;
                this.showStart=false;
                this.search();
            },
            search (){//搜索
                let that=this;
               that.$api.get(
                that.jumuc.getUserSysMilkDiscount,
                {orderTime:this.startTime,userId:this.userId},
                successRes => {
                    if (successRes.success) {
                        that.data = successRes.data
                    } else {
                        that.isData = true
                        that.msg=successRes.msg
                    }
                })
            },
             formatter(type, value) {
                if (type === 'year') {
                    return `${value}年`;
                } else if (type === 'month') {
                    return `${value}月`
                }
                return value;
                },
                p(s) {
                return s < 10 ? '0' + s : s
            },
            
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    #antzone {
        width: 1000px;
        height: 50px;
        background: #CCC;
        position: fixed;
        left: 0;
        bottom: 0px;
    }

    .jump-cart {

        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 90%;
                }
            }

            h4 {
                font-size: 14px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 14px;
                &.item-time {
                    color: @bule-thame;
                    font-size: 16px;
                    text-align: right;
                }
                &.item-price {
                    color: red;
                    font-size: 16px;
                    i {
                        font-size: 18px;
                        float: right;
                        color: #f5a623
                    }
                }
            }
        }
    }
</style>

